import script from "./list-checkbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./list-checkbox.vue?vue&type=script&setup=true&lang=ts"

import "./list-checkbox.vue?vue&type=style&index=0&id=f78a9536&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f78a9536"]])

export default __exports__